// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__1ddQf","unreadBadge":"styles_unreadBadge___u6y1","modalContent":"styles_modalContent__2_Sjg","modal":"styles_modal__3jPUh"};